import { render, staticRenderFns } from "./MessageDetail.vue?vue&type=template&id=7a22ca82&scoped=true"
import script from "./MessageDetail.vue?vue&type=script&lang=js"
export * from "./MessageDetail.vue?vue&type=script&lang=js"
import style0 from "./MessageDetail.vue?vue&type=style&index=0&id=7a22ca82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a22ca82",
  null
  
)

export default component.exports